import { useProjectContext } from "@contexts/projects";
import { formatNumberToLocale } from "@utils/formatNumber";
import { metricPresentation, metricReasonStyle } from "@utils/metricPresentation";
import { useState } from "react";


export const Accordion = ({ item, count }) => {
  const [isOpen, setIsOpen] = useState(count == 1);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  if (item.title === 'undefined - undefined') return

  return (
    <>
      <span onClick={toggleAccordion} className="eap-item">
        <span className="eap-type">{item.type}</span> {item.title}
      </span>
      {isOpen && item.subs && (
        <div>
          {item.subs.map(subItem => (
            <Accordion key={subItem.title} item={subItem} count={count} />
          ))}
        </div>
      )}
    </>
  );
};

export const renderRow = (label, value) => {
  return <div className="data">
    <span className="label">{label}</span>
    <span className="value">{value}</span>
  </div>
}

const getLength = (value) => {
  if (typeof value !== "number" || !Number.isFinite(value)) return ''
  const formated = formatNumberToLocale(value)
  if (formated.length > 13) return 'font-s'
  if (formated.length === 13) return 'font-m'
  return ''
}

export const renderCard = (label, value) => {
  const available = typeof value === "number" && Number.isFinite(value)
  return <div className="card">
    <span className="card-title">{label}</span>
    <span className={`card-value ${available ? getLength(value) : ''} ${label === 'IDC' && available ? (value < 1 ? 'color-red' : 'color-green') : undefined}`}>
      {available ? formatNumberToLocale(value) : "—"}
    </span>
  </div>
}

export const renderMetricCard = (label, envelope, reasonId) => {
  const presented = metricPresentation(envelope, { formatter: formatNumberToLocale, reasonId });
  return <div className="card">
    <span className="card-title">{label}</span>
    <span
      className={`card-value ${presented.available ? getLength(presented.value) : ''} ${label === 'IDC' && presented.available ? (presented.value < 1 ? 'color-red' : 'color-green') : ''}`}
      aria-describedby={presented.describedBy}
    >
      {presented.text}
    </span>
    {!presented.available && (
      <span id={presented.describedBy} style={metricReasonStyle}>{presented.reason}</span>
    )}
  </div>
}

export const formatWBS = (wbs) => {
  const { selectedDetail: activeProject } = useProjectContext();

  if (!wbs) return
  const wbs_id = wbs?.replace(activeProject.wbs_code_id, '') ?? 0

  if (wbs_id.length === 11) {
    return wbs_id.replace(/(\d{3})(\d{2})(\d{3})(\d{3})/, '$1.$2.$3.$4');
  } else {
    return wbs_id.replace(/(\d{3})(\d{2})(\d{3})(\d{3})(\d{3})/, '$1.$2.$3.$4.$5');
  }
}

export const renderOptionalCard = (label, value) => {
  const available = value !== null && value !== undefined && Number.isFinite(Number(value));
  return <div className="card">
    <span className="card-title">{label}</span>
    <span className={`card-value ${available ? getLength(value) : ''}`}>
      {available ? formatNumberToLocale(Number(value)) : "—"}
    </span>
  </div>
}
